import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { RankBadge } from "@/components/RankBadge";
import { Flame, Trophy } from "lucide-react";

const TABS = [
  { key: "all", label: "Tổng (ELO)" },
  { key: "today", label: "Hôm nay" },
  { key: "week", label: "Tuần" },
  { key: "month", label: "Tháng" },
  { key: "streak", label: "Chuỗi thắng" },
  { key: "wins", label: "Số trận thắng" },
];

export default function AdminLeaderboard() {
  const [period, setPeriod] = useState("all");
  const [rows, setRows] = useState([]);

  useEffect(() => {
    api.get(`/leaderboard?period=${period}&limit=100`).then(({ data }) => setRows(data));
  }, [period]);

  return (
    <div className="p-6 lg:p-8">
      <h1 className="font-display font-bold text-3xl mb-1 flex items-center gap-3"><Trophy className="text-yellow-400" /> Bảng xếp hạng</h1>
      <p className="text-white/40 text-sm mb-6">Theo dõi top theo nhiều tiêu chí</p>

      <div className="flex flex-wrap gap-2 mb-5">
        {TABS.map((t) => (
          <button key={t.key} onClick={() => setPeriod(t.key)}
            className={`px-4 py-2 rounded-md text-sm ${period === t.key ? "bg-cyan-400/10 text-cyan-300 border border-cyan-400/40" : "bg-white/[0.03] text-white/60 border border-white/8 hover:bg-white/5"}`}>
            {t.label}
          </button>
        ))}
      </div>

      <div className="rounded-xl bg-[#0c0d14] border border-white/8 overflow-hidden">
        <div className="grid grid-cols-12 px-5 py-3 text-[10px] uppercase tracking-widest text-white/40 border-b border-white/8">
          <div className="col-span-1">#</div>
          <div className="col-span-4">Người chơi</div>
          <div className="col-span-2">Rank</div>
          <div className="col-span-1 text-right">ELO</div>
          <div className="col-span-1 text-right">Trận</div>
          <div className="col-span-1 text-right">Thắng</div>
          <div className="col-span-1 text-right">Win%</div>
          <div className="col-span-1 text-right">Streak</div>
        </div>
        {rows.map((p, i) => (
          <div key={p.id} className="grid grid-cols-12 items-center px-5 py-2.5 border-b border-white/5 hover:bg-white/[0.03]">
            <div className="col-span-1 font-mono-num text-sm text-white/60">{i + 1}</div>
            <div className="col-span-4 flex items-center gap-3 min-w-0">
              <img src={p.avatar_url} alt="" className="w-8 h-8 rounded-full" />
              <div className="min-w-0">
                <div className="text-sm truncate">{p.nickname}</div>
                <div className="text-xs text-white/40 truncate">@{p.username}</div>
              </div>
            </div>
            <div className="col-span-2"><RankBadge elo={p.elo} size="sm" showElo={false} /></div>
            <div className="col-span-1 text-right font-display font-bold">{p.elo}</div>
            <div className="col-span-1 text-right text-sm text-white/70">{p.total_matches}</div>
            <div className="col-span-1 text-right text-sm text-cyan-300">{p.wins}</div>
            <div className="col-span-1 text-right text-sm text-white/70">{p.win_rate}%</div>
            <div className="col-span-1 text-right flex items-center justify-end gap-1 text-red-400 text-sm"><Flame size={11} />{p.win_streak}</div>
          </div>
        ))}
        {rows.length === 0 && <div className="py-12 text-center text-white/40 text-sm">Không có dữ liệu</div>}
      </div>
    </div>
  );
}
